export default "__VITE_ASSET__DFKFO9yC__"